<template>
  <Labelled
    :label="label"
    :help-text="helpText"
  > 
    <template v-if="disabled">
      <div v-for="value of internalValue" :key="value" class="tag disabled">
        {{$t(`scheduledReports.fields.${value}`)}}
      </div>
    </template>
    <template v-else>
      <draggable
        v-model="internalValue"
        :group="{ name: 'tags', pull: 'clone', put: false }"
        animation="150"
      >
        <div v-for="value of internalValue" :key="value" class="tag">
          {{$t(`scheduledReports.fields.${value}`)}}
        </div>
      </draggable>
    </template>
    <!-- {{internalValue}} -->
  </Labelled>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  name: 'DraggableTags',
  props: {
    value: Array,
    label: String,
    helpText: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: [],
    }
  },
  mounted() {
    this.$watch('value', (val) => {
      this.internalValue = val
    }, { immediate: true })

    this.$watch('internalValue', this.update)
  },
  methods: {
    update() {
      this.$emit('input', this.internalValue)
    },
  },
  components: {
    Draggable
  }
}
</script>

<style lang="scss" scoped>
.tag {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  padding: 5px 8px;
  background: #dfe3e7;
  // background: red;
  border-radius: 3px;
  color: #2b3640;
  cursor: move;
  margin: 7px 4px 0px 4px;
  &.disabled {
    cursor: default;
  }
}
</style>